export enum ETransmittalReviewResponseFormKey {
  REVIEW_RESPONSE = 'reviewResponse',
  DESIGNER_ATTACHMENTS = 'designerAttachments',
  COMMENT = 'comment',
}

export enum ETransmittalConfirmationActionType {
  save,
  delete,
  requestEndorsement,
  endorse,
  releaseForConstruction,
  signAndSend,
  prepareApproval,
  prepareReview,
}

export const transmittalDistributionFormKeys = {
  GROUP: 'group',
  USER_ROLE: 'userRoles',
  TEAM: 'team',
  INDIVIDUAL_USER: 'individualUser',
};

export const transmittalDetailExportFormKeys = {
  PACKAGE: 'package',
  COVER_SHEET: 'coverSheet',
};

export const transmittalFileUploadFormKeys = {
  DOC_NO: 'docNo',
  DESCRIPTION: 'description',
  DATE: 'date',
  DOC_TYPE: 'docType',
  REMOVE_FROM_USE: 'removeFromUse',
};

export enum ETransmittalDetailsFormKeys {
  PURPOSE_OF_ISSUE = 'purpose',
  RSE = 'rse',
  REMARK = 'remark',
  CHANGE_T3 = 'designModifications',
  DOCUMENTS = 'documents',
}

export enum ETransmittalFileTypes {
  drawing = 'Drawing',
  designReport = 'Design Report',
  responseToComment = 'Response to Comment',
  other = 'Other',
  cert = 'Cert',
  comment = 'Comment',
  distribution = 'Distribution',
}

export enum ETransmittalItemTypes {
  DESIGNER = 'DESIGNER',
  SITE = 'SITE',
  LIR = 'LIR',
  CHECKER = 'ICE',
}

export enum EReviewResponseFormStatus {
  APPROVED = 'RA',
  APPROVED_WITH_COMMENT = 'RAC',
  COMMENTED = 'RC',
  CANCELLED = 'C',
}

export const reviewResponseCheckOptions = [
  {
    key: 1,
    text: 'Approved',
    data: EReviewResponseFormStatus.APPROVED,
  },
  {
    key: 2,
    text: 'Approved with comment',
    data: EReviewResponseFormStatus.APPROVED_WITH_COMMENT,
  },
  {
    key: 3,
    text: 'Commented',
    data: EReviewResponseFormStatus.COMMENTED,
  },
];
